module.exports = __webpack_public_path__ + "img/f79b6301ac6e43f4b0f2fe99aac20a8b.7c7b6471.jpg";